import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { QuillModule } from 'ngx-quill';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormioModule } from 'angular-material-formio';
import { InlineSVGModule } from 'ng-inline-svg';
import { CoreModule } from '../../../core/core.module';
import { PartialsModule } from '../../partials/partials.module';
import { DocumentsManagementRoutingModule } from './documents-management-routing.module';
import { categoryReducer } from './reducers/category.reducer';
import { documentReducer } from './reducers/document.reducer';
import { accessHistoryReducer } from './reducers/access-history.reducer';
import { CategoryEffects, DocumentEffects, AccessHistoryEffects } from './effects';
import { DocExtensionPipe } from './pipes';
import {
  CategoryListComponent,
  CreateCategoryComponent,
  DocumentListComponent,
  CreateDocumentComponent,
  AssignEntityComponent,
  SelectRelationComponent,
  DocsViewerComponent,
  AccessHistoryListComponent,
  SharingDocConfigComponent,
  ShareDocumentComponent,
} from './components';

@NgModule({
  declarations: [
    DocExtensionPipe,
    CategoryListComponent,
    CreateCategoryComponent,
    DocumentListComponent,
    CreateDocumentComponent,
    AssignEntityComponent,
    SelectRelationComponent,
    DocsViewerComponent,
    AccessHistoryListComponent,
    SharingDocConfigComponent,
    ShareDocumentComponent,
  ],
  entryComponents: [
    CreateCategoryComponent,
    DocumentListComponent,
    CreateDocumentComponent,
    AssignEntityComponent,
    SelectRelationComponent,
    AccessHistoryListComponent,
    SharingDocConfigComponent,
    ShareDocumentComponent,
  ],
  imports: [
    DocumentsManagementRoutingModule,
    CommonModule,
    StoreModule.forFeature('category', categoryReducer),
    EffectsModule.forFeature([CategoryEffects]),
    StoreModule.forFeature('document', documentReducer),
    EffectsModule.forFeature([DocumentEffects]),
    StoreModule.forFeature('accessHistory', accessHistoryReducer),
    EffectsModule.forFeature([AccessHistoryEffects]),
    NgxPermissionsModule.forChild(),
    PerfectScrollbarModule,
    NgxExtendedPdfViewerModule,
    QuillModule,
    TranslateModule,
    ReactiveFormsModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatFormioModule,
    InlineSVGModule,
    CoreModule,
    PartialsModule,
  ],
  exports: [DocumentListComponent, DocsViewerComponent],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class DocumentsManagementModule {}
